import { Link } from 'react-router';

import { onlineCourseQuizQuestionLinkedSectionClicked } from 'my-core/gtm-events';
import { getActivityTypeConfig } from 'my-core/online-course-activity-utils';
import { onlineCourseSectionPath } from 'my-core/routes';

import LatexString from 'my-elements/LatexString';

import Avatar from '@mui/material/Avatar';
import CardActionArea from '@mui/material/CardActionArea';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ shadows, shape, spacing }) => ({
  marginTop: spacing(6),
  '.LOCS-section': {
    marginTop: spacing(1),
    overflow: 'hidden',
    boxShadow: shadows.states.clickable,
    borderRadius: shape.borderRadiusSm,
  },
  '.LOCS-sectionContent': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: spacing(1, 2),
  },
  '.LOCS-icon': {
    marginRight: spacing(2),
    fontSize: 14,
    height: '2em',
    width: '2em',
  },
});

export default function LinkedOnlineCourseSections({ eventTrackingProperties, question }) {
  if (!question.linked_oc_sections?.length) return null;

  return (
    <div css={rootCss}>
      <Typography gutterBottom variant="subtitle1">
        Learn More:
      </Typography>
      {question.linked_oc_sections.map(sect => (
        <Paper key={sect.id} className="LOCS-section">
          <CardActionArea
            className="LOCS-sectionContent"
            component={Link}
            nativeButton={false}
            onClick={() =>
              onlineCourseQuizQuestionLinkedSectionClicked({
                ...eventTrackingProperties,
                quiz_question_id: question.id,
              })
            }
            to={sect.path || onlineCourseSectionPath(sect.online_course_id, sect.id, sect.course_slug)}
          >
            <Avatar className="LOCS-icon">
              <FontAwesomeIcon icon={getActivityTypeConfig({}).icon} />
            </Avatar>
            <div>
              <Typography
                component="p"
                sx={{
                  color: 'text.secondary',
                }}
                variant="overline"
              >
                {sect.course_code}
              </Typography>
              <Typography>
                <LatexString>{[sect.chapter_title, sect.title].join(' > ')}</LatexString>
              </Typography>
            </div>
          </CardActionArea>
        </Paper>
      ))}
    </div>
  );
}
